export const iconFontAwesomeEmojiFaceFrownOpen = (
	<i className="fa-solid fa-face-frown-open"></i>
);
